import React from "react";
import { IMAGES } from "../../utils/imageAssets";
import "./AppInstallPage.css";
import Banner from "../Banner/Banner";
import {useMembership} from "../../hooks/MembershipProvider/MembershipProvider";
import useAndroidBridge from "../../hooks/useAndroidBridge";


const AppInstallPage: React.FC = () => {
  const { isEmbed } = useMembership();
  const { sendToAndroid, bridgeLogout } = useAndroidBridge();
  
  const getLink = (url:string) => {
    window.open(url);
  }
  
  const btns = [
    {
      label:`google`,
      url:`https://play.google.com/store/apps/details?id=kr.co.utopsoft.vcall&pcampaignid=web_share`,
    },
    // {
    //   label:`apple`,
    //   url:``,
    // },
  ];
  
  
  return (
    <>
      {isEmbed() && (
        <div className={`mobile_app_header justify-end`}>
          <button onClick={() => sendToAndroid("go-to-page", "")} className={`btn btn_close`}></button>
        </div>
      )}
      <div className={`content_wrap app_link`}>
        <div className={`section_wrap text-center`}>
          <div className={`sec sec_1`}>
            <img src={`../contents/appicon.png`} alt={`기억의 서랍`} className={`img`}/>
            <h3 className={`tit`}>
              앱 다운로드하고<br/>
              나의 이야기를 시작해 보세요.
            </h3>
            <p className={`txt`}>기억의 서랍 앱 다운로드</p>
            <div className={`btn_group`}>
              {btns?.map((obj,idx)=>{
                return (
                  <button key={idx} className={`btn btn_${obj?.label}`} onClick={()=>getLink(obj?.url)}></button>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppInstallPage;
